// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ERpc-","title":"Header_title__3fHNr","left":"Header_left__2m1HJ","clinicName":"Header_clinicName__B4yOu"};